import api from '../index';

const baseUrl = '/customer';

export const addCustomerVehicleApi = (data) => {
  return api({
    method: 'post',
    url: `${baseUrl}/add-customer-vehicle`,
    data,
  });
};

export const addCustomerApi = (data) => {
  return api({
    method: 'post',
    url: `${baseUrl}/save-customer`,
    data,
  });
};

export const getCustomerList = (query) => {
  return api({
    method: 'get',
    url: `${baseUrl}/get-customers?${query}`,
  });
};

export const deleteCustomerApi = (id) => {
  return api({
    method: 'delete',
    url: `${baseUrl}/delete-customer/${id}`,
  });
};

export const getCustomer = (data) => {
  return api({
    method: 'post',
    url: `${baseUrl}/get-customer`,
    data,
  });
};

export const updateCustomerApi = (data) => {
  return api({
    method: 'put',
    url: `${baseUrl}/update-customer`,
    data,
  });
};

export const getServiceHistoryApi = (data) => {
  return api({
    method: 'post',
    url: '/repairOrder/get-service-history',
    data,
  });
};

export const exportCustomerAPi = (query) => {
  return api({
    method: 'post',
    url: `${baseUrl}/export-customer?${query}`,
  });
};

export const importCustomerVehicleApi = (file, handleUploadProgress) => {
  return api({
    method: 'post',
    url: `${baseUrl}/import-customer-vehicle-file`,
    data: file,
    onUploadProgress: (progressEvent) => {
      const { loaded, total } = progressEvent;
      const percent = Math.floor((loaded * 100) / total);
      handleUploadProgress(percent);
    },
  });
};

export const searchCustomerApi = ({ searchValue }) => {
  return api({
    method: 'get',
    url: `${baseUrl}/search?searchValue=${searchValue}`,
  });
};
export const getCustomerVehicles = (cId) => {
  return api({
    method: 'get',
    url: `${baseUrl}/get-customer-vehicles/${cId}`,
  });
};
export const addEditCustomer = (data) => {
  return api({
    method: 'post',
    url: `${baseUrl}/add-edit-customer`,
    data,
  });
};
